<template>
    <f7-page
        :page-content="false"
        name="Onboarding 1"
        navbar-hidden
        no-navbar
        class="onboardingBg"
    >
        <div class="bg-wrapper">
            <div class="parallax-bg" />
            <div class="parallax-bg-2" />
            <div style="max-width: 400px; margin: 160px auto 0">
                <f7-block>
                    <h2>
                        Tell us about yourself to personalize your journey
                    </h2>
                    <f7-block>
                        Coral uses factors like your age, who you're attracted to and your relationship status to create a sexual wellness journey just for you.
                    </f7-block>
                </f7-block>
            </div>
            <div class="absBottom safe-area-bottom">
                <div class="coral" />
                <div style="margin: -100px auto 0px; max-width: 260px;">
                    <f7-button
                        :color="'red'"
                        fill
                        href="#"
                        round
                        style="width: 260px"
                        @click="goToNextPage"
                    >Continue</f7-button>
                </div>
            </div>
        </div>
    </f7-page>
</template>

<script>
export default {
    store: ['api', 'user'],
    data () {
        return {
        }
    },
    computed: {
        device: function () {
            return f7.device;
        }
    },
    created: function () {
        let panel = f7.panel.get('.panel-left');
        panel.params.visibleBreakpoint = 768;
        panel.disableVisibleBreakpoint();
        if (!localStore.getItem('notifications-sms') && this.user.phone) {
            this.$events.fire('notifications-sms', true);
        }
    },
    beforeDestroy: function () {

    },
    mounted: function () { },
    methods: {
        goToNextPage: function () {
            f7.views['main'].router.navigate('/onboarding2');
        },
    }
};
</script>

<style lang="less" scoped>
.bg-wrapper {
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
}
.parallax-bg {
    position: absolute;
    left: calc(~'-400px' - 50vw);
    top: 0;
    background: url(https://data.getcoral.app/images/1.2.0/onboarding_top.png) top right no-repeat;
    background-size: 3670.5px 171.5px;
    height: 171.5px;
    width: 3670.5px;
}
.parallax-bg-2 {
    position: absolute;
    left: calc(~'-3250px' - 50vw);
    bottom: 0px;
    background: url(https://data.getcoral.app/images/1.2.0/onboarding_bottom.png) bottom left
        no-repeat;
    background-size: 5954.5px 804px;
    height: 804px;
    width: 5954.5px;
}
.coral {
    background: url(../../img/1.2.0/coral.png) bottom right no-repeat;
    background-size: 221px 278px;
    height: 278px;
    width: 221px;
    margin: 0 auto 90px;
    position: relative;
    .coral_growth {
        position: absolute;
        bottom: 0;
        background: url(../../img/1.2.0/coral_growth.png) bottom right no-repeat;
        background-size: 205px 212.5px;
        height: 0;
        border-radius: 30%;
        width: 233px;
        opacity: 0.3;
        transition: all 5s ease-out;
        &.growing {
            opacity: 1;
            height: 212.5px;
            width: 233px;
        }
    }
}
.absBottom {
    overflow: visible;
    text-align: center;
    position: absolute;
    z-index: 100000;
    bottom: 50px;
    width: 100%;
    margin: 0;
}
.theme-dark {
    h2 {
        color: white;
    }
}
</style>
